import { defineMessages } from "react-intl";

export const formPdfViewerItemText = defineMessages({
  prevPage: {
    defaultMessage: "Previous Page",
    id: "6TbqAD",
  },
  nextPage: {
    defaultMessage: "Next Page",
    id: "uuLnK5",
  },
  download: {
    defaultMessage: "Download",
    id: "5q3qC0",
  },
  error: {
    defaultMessage: "PDF could not be loaded.",
    id: "BqqoHe",
  },
  pageNumber: {
    defaultMessage: "Page {pageNumber} of {totalPages}",
    id: "yI5m9x",
  },
});
